export const CATEGORY_STRUCTURE = [
  {
    id: 1,
    name: "سگ",
    subcategories: [
      { id: 8, name: "غذای خشک سگ" },
      { id: 9, name: "تشویقی و اسنک" },
      { id: 3, name: "لوازم و تجهیزات" },
      { id: 10, name: "مکمل و ویتامین" },
    ],
  },
  {
    id: 2,
    name: "گربه",
    subcategories: [
      { id: 11, name: "غذای خشک گربه" },
      { id: 12, name: "کنسرو و پوچ" },
      { id: 13, name: "تشویقی" },
    ],
  },
  {
    id: 3,
    name: "لوازم و تجهیزات",
    subcategories: [{ id: 10, name: "مکمل و ویتامین" }],
  },
  {
    id: 4,
    name: "پرندگان",
    subcategories: [
      { id: 14, name: "غذای گونه‌های مختلف" },
      { id: 15, name: "مکمل‌ها" },
      { id: 16, name: "اسباب‌بازی" },
      { id: 17, name: "لوازم بهداشتی" },
    ],
  },
  {
    id: 5,
    name: "جوندگان و اگزوتیک",
    subcategories: [
      { id: 18, name: "غذای خرگوش، همستر، خوکچه" },
      { id: 19, name: "بستر و جای خواب" },
      { id: 20, name: "اسباب‌بازی و لوازم بهداشتی" },
    ],
  },
  {
    id: 6,
    name: "محصولات بهداشتی و دارو",
    subcategories: [
      { id: 21, name: "شامپو و بهداشت" },
      { id: 22, name: "دارو و مکمل تخصصی" },
    ],
  },
  {
    id: 7,
    name: "اکسسوری",
    subcategories: [
      { id: 23, name: "قلاده، لباس و هارنس" },
      { id: 24, name: "ظروف و فیدر" },
    ],
  },
];

